import {払出修正候補編集レコード型} from '@/type/withdrawal/records/modify/払出修正候補編集レコード型';

export interface 払出修正依頼型 {
  部署コード: string;
  商品コード: string;
  払出シーケンス番号: number;
  払出伝票番号: number;
  払出伝票行番号: number;
  払出日: Date | null;
  払出箱数: number;
  払出バラ数: number;
  払出有効期限: Date;
  払出入力方法区分: string;
  入数: number;
  更新バージョン: number;
}

export function to払出修正依頼型(record: 払出修正候補編集レコード型): 払出修正依頼型 {
  return {
    部署コード: record.部署コード,
    商品コード: record.元レコード.商品コード,
    払出シーケンス番号: record.元レコード.払出シーケンス番号,
    払出伝票番号: record.元レコード.払出伝票番号,
    払出伝票行番号: record.元レコード.払出伝票行番号,
    払出日: record.払出日,
    払出箱数: record.払出箱数,
    払出バラ数: record.払出バラ数,
    払出有効期限: record.元レコード.払出有効期限,
    払出入力方法区分: record.元レコード.払出入力方法区分,
    入数: record.元レコード.入数,
    更新バージョン: record.元レコード.更新バージョン,
  };
}
